<button (click)="openModal()">ایجاد</button>

<app-pagination [total]="total" [limit]="limit" (page)="load($event.from)"></app-pagination>
<div *ngFor="let assessment of assessments">
  <app-assessment-test [assessment]="assessment" mode="admin">
    <div toolbar>
      <button (click)="openModal(assessment)">ویرایش</button>
    </div>
  </app-assessment-test>
</div>

<ngx-smart-modal #assessmentModal identifier="assessmentModal" customClass="full-width">
  <div *ngIf="selected">
    <input type="text" [(ngModel)]="selected.Title" />
    <div *ngFor="let question of selected.Questions; let i=index">
      <input type="text" [(ngModel)]="question.Title" />
      <select [(ngModel)]="question.Type">
        <option value="0">تک انتخابی</option>
        <option value="1">چند انتخابی</option>
        <option value="2">تشریحی</option>
      </select>
      <div *ngFor="let option of question.Options; let j=index">
        <input type="text" [(ngModel)]="option.Title" />
        <input type="text" [(ngModel)]="option.Value" />
      </div>
      <button (click)="addOption(question)">افزودن گزینه</button>
    </div>
    <button (click)="addQuestion(selected)">افزودن سوال</button>
    <button (click)="save(selected)">ذخیره</button>
  </div>
</ngx-smart-modal>